// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","339":"storefront","533":"safety","696":"promo","884":"admin"}[chunkId] || chunkId) + "." + {"18":"769081b7","73":"19c750e6","85":"1b39b07c","339":"0c54133d","533":"30a3dbae","556":"b2d7ef72","696":"e75a0abb","884":"0a8f5453"}[chunkId] + ".chunk.js";
};